import React, { useEffect, useState } from 'react';
import Icon from '../components/Icon';
import API from '../services/api';
import { useLanguage } from '../context/LanguageContext';
import PageHeader from '../components/PageHeader';
import DataTable from '../components/DataTable';
import PersonPicker from '../components/PersonPicker';
import Modal from '../components/Modal';
import { FormField, Input, Select, SubmitBtn } from '../components/FormField';

const ALL_POSITIONS = [
  'Anbar koordinatoru','Baş maliyyə rəhbəri','Baş qrafik və animasiya dizayneri, video redaktor',
  'Böyük mühasib','Dayə','Dülgər','Fotoqraf və videoqraf','Gözətçi','Gözətçilərin koordinatoru',
  'Həkim','Hovuz xidmətçisi','Hüquq və hüquqi komplayens üzrə mütəxəssis',
  'İbtidai siniflər üzrə kitabxanaçı','İbtidai təhsil pilləsi üzrə lider',
  'İngilis dili üzrə tərbiyəçi','İngilis dili üzrə tərbiyəçi assistenti',
  'İnnovasiyalar üzrə koordinator','İnsan resursları üzrə generalist','İnsan resursları şöbəsinin meneceri',
  'İşə qəbul üzrə mütəxəssis','İstismar və texniki təminat üzrə koordinator',
  'İT koordinator','IT Mütəxəssisi','Sistem Administratoru','Şəbəkə Mühəndisi',
  'Kafeteriya üzrə xidmət işçisi','Kamera müşahidə operatoru',
  'Katiblik şöbəsinin koordinatoru','Katiblik şöbəsinin mütəxəssisi, qeydiyyatçı',
  'Kitabxana koordinatoru','Kitabxana operatoru','Klublar üzrə koordinator',
  'Kompleksin İcraçı direktoru','Koordinator','Laborant','Maliyyə nəzarətçisi',
  'Marketinq şöbəsinin koordinatoru','Məktəb direktoru',
  'Məktəb direktorunun milli kurikulum üzrə müavini','Məktəb Direktorunun Şəxsi Köməkçi',
  'Məktəbəqədər təhsil pilləsi üzrə lider','Məşqçi','Müəllim','Müəllim assistenti','Mühasib',
  'Nəşr işləri üzrə mütəxəssis','Növbə rəisi','Orta təhsil pilləsi üzrə lider',
  'PR və layihələr üzrə koordinator','Psixoloq','Qazanxana növbətçisi','Referent',
  'Rəssam tərtibatçı','Şagird qəbulu şöbəsinin koordinatoru','Şagirdlərin qəbulu üzrə mütəxəssis',
  'Santexnik','Satış və inzibati xidmətlər üzrə mütəxəssis','SƏTƏM üzrə mütəxəssis',
  'Sinif rəhbəri, Ali təhsil üzrə məsləhətçi','SMM, reels maker',
  'Su hovuzu və idman qurğuları üzrə mexanik','Sürücü',
  'Təchizat üzrə koordinator','Təchizat üzrə mütəxəssis',
  'Təhsil məsələləri üzrə məsləhətçi','Təhsil strategiyaları üzrə konsultant',
  'Təhsilin inkişafı üzrə məktəb direktorunun müavini',
  'Təmizlik üzrə nəzarətçi','Təmizlik üzrə xidmətçi','Texniki işçi',
  'Texniki problemlər üzrə mütəxəssis','Tibb bacısı','Tikiş sexinin operatoru',
  'Yuxarı təhsil pilləsi üzrə lider','Digər',
];

export default function Users() {
  const { t, lang } = useLanguage();
  const ROLES = [
    { value: 'admin',           label: t('users.roleAdmin'),       color: '#7c3aed', desc: t('users.roleAdminDesc') },
    { value: 'department_head', label: t('users.roleManagement'),  color: '#007c82', desc: t('users.roleManagementDesc') },
    { value: 'staff',           label: t('users.roleStaff'),       color: '#0369a1', desc: t('users.roleStaffDesc') },
    { value: 'teacher',         label: t('users.roleTeacher'),     color: '#059669', desc: t('users.roleTeacherDesc') },
    { value: 'student',         label: t('users.roleStudent'),     color: '#d97706', desc: t('users.roleStudentDesc') },
    { value: 'parent',          label: t('users.roleParent'),      color: '#dc2626', desc: t('users.roleParentDesc') },
  ];
  const ROLE_MAP = Object.fromEntries(ROLES.map(r => [r.value, r]));
  const tPos = (p) => lang === 'en' ? (t('positions.' + p, p)) : p;
  const POSITIONS = {
    admin:           ALL_POSITIONS,
    department_head: ALL_POSITIONS,
    staff:           ALL_POSITIONS,
    teacher:         ALL_POSITIONS,
    student:         ['Şagird'],
    parent:          ['Valideyn','Qəyyum'],
  };

  const me = JSON.parse(localStorage.getItem('user') || '{}');
  const isAdmin = me.role === 'admin';

  const [users, setUsers]         = useState([]);
  const [departments, setDepts]   = useState([]);
  const [loading, setLoading]     = useState(true);
  const [modal, setModal]         = useState(null);
  const [form, setForm]           = useState({ name:'', email:'', username:'', password:'', role:'teacher', position:'', phone:'', is_active:1, department_id:'' });
  const [saving, setSaving]       = useState(false);
  const [search, setSearch]       = useState('');
  const [filterRole, setFilterRole] = useState('');
  const [filterDept, setFilterDept] = useState('');
  const [onlyNeedsSetup, setOnlyNeedsSetup] = useState(false);
  const [customPos, setCustomPos] = useState(false);
  const [showPwd, setShowPwd] = useState(false);

  const [loadError, setLoadError] = useState('');
  const load = () => {
    setLoading(true);
    setLoadError('');
    Promise.all([API.get('/users'), API.get('/departments')])
      .then(([u, d]) => { setUsers(u.data); setDepts(d.data); })
      .catch(err => {
        const msg = err.response?.data?.message || err.message || 'Network error';
        setLoadError(`${err.response?.status || ''} ${msg}`.trim());
      })
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const openAdd = () => {
    setForm({ name:'', email:'', username:'', password:'', role:'teacher', position:'', phone:'', is_active:1, department_id:'',
      menu_permissions: ['dashboard','students','classes','subjects','attendance','grades','timetable-builder','announcements','requests'] });
    setCustomPos(false);
    setModal('add');
  };
  const openEdit = (u) => {
    const perms = typeof u.menu_permissions === 'string' ? JSON.parse(u.menu_permissions || '[]') : (u.menu_permissions || []);
    setForm({ ...u, password:'', department_id: u.department_id || '', manager_id: u.manager_id || '', menu_permissions: perms });
    const pl = POSITIONS[u.role] || [];
    setCustomPos(u.position && !pl.filter(p => p !== 'Digər').includes(u.position));
    setModal('edit');
  };

  const handleSave = async e => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = { ...form };
      if (payload.menu_permissions && typeof payload.menu_permissions === 'string') {
        try { payload.menu_permissions = JSON.parse(payload.menu_permissions); } catch(e) {}
      }
      if (modal === 'add') await API.post('/users', payload);
      else await API.put('/users/' + payload.id, payload);
      setModal(null);
      load();
    } catch (err) {
      alert(err.response?.data?.message || t('users.error'));
    } finally { setSaving(false); }
  };

  const handleDelete = async (u) => {
    if (!window.confirm(u.name + ' ' + t('users.confirmDelete'))) return;
    await API.delete('/users/' + u.id);
    load();
  };

  const activeFilter = filterRole || '_staff';
  const filtered = users.filter(u => {
    const q = search.toLowerCase();
    const matchSearch = !q || (u.name||'').toLowerCase().includes(q) || (u.username||'').toLowerCase().includes(q) || (u.email||'').toLowerCase().includes(q) || (u.position||'').toLowerCase().includes(q);
    const matchRole = activeFilter === '_all' ? true : activeFilter === '_staff' ? !['student','parent'].includes(u.role) : u.role === activeFilter;
    const matchDept = !filterDept || String(u.department_id) === String(filterDept);
    const matchSetup = !onlyNeedsSetup || !!u.needs_setup;
    return matchSearch && matchRole && matchDept && matchSetup;
  })
  // Tənzimlənməmişlər həmişə yuxarıda — axtarmağa ehtiyac qalmasın
  .sort((a, b) => (b.needs_setup ? 1 : 0) - (a.needs_setup ? 1 : 0));

  const needsSetupCount = users.filter(u => u.needs_setup).length;

  const staffCount = users.filter(u => !['student','parent'].includes(u.role)).length;
  const counts = ROLES.map(r => ({ ...r, count: users.filter(u => u.role === r.value).length }));
  const posList = POSITIONS[form.role] || [];
  const showDept = ['admin','department_head','staff'].includes(form.role);

  const columns = [
    { header: '#', render: (r, i) => i + 1, width: '44px' },
    {
      header: t('users.colUser'),
      render: u => (
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          {u.avatar ? (
            <img src={u.avatar} alt="" style={{width:36,height:36,borderRadius:'50%',objectFit:'cover',flexShrink:0}} />
          ) : (
            <div style={{
              width:36, height:36, borderRadius:'50%', flexShrink:0,
              background: (ROLE_MAP[u.role]?.color || '#6b7280') + '20',
              color: ROLE_MAP[u.role]?.color || '#6b7280',
              display:'flex', alignItems:'center', justifyContent:'center',
              fontWeight:700, fontSize:'0.95rem'
            }}>
              {(u.name || '?').charAt(0).toUpperCase()}
            </div>
          )}
          <div>
            <div style={{ display:'flex', alignItems:'center', gap:7, flexWrap:'wrap' }}>
              <span style={{ fontWeight:600, fontSize:'0.88rem', color:'#111827' }}>{u.name}</span>
              {/* Microsoft ilə yeni girib, admin hələ rol/vəzifə təyin etməyib.
                  Yazı götürüldü — sətrin sarı fonu onsuz da bunu bildirir;
                  yalnız kiçik nöqtə qalır ki, ipucu ilə izah oxunsun. */}
              {!!u.needs_setup && (
                <span className="needs-setup-dot" title={t('users.needsSetupHint')} />
              )}            </div>
            <div style={{ fontSize:'0.74rem', color:'#9ca3af' }}>@{u.username}</div>
          </div>
        </div>
      )
    },
    {
      header: t('users.colPositionDept'),
      render: u => (
        <div>
          <div style={{ fontSize:'0.85rem', color:'#374151', fontWeight:500 }}>{u.position ? tPos(u.position) : '—'}</div>
          {u.department_name && (
            <div style={{ fontSize:'0.74rem', color:'#007c82', fontWeight:600, marginTop:2 }}>
              {lang === 'en' ? t('departments.' + u.department_name, u.department_name) : u.department_name}
            </div>
          )}
        </div>
      )
    },
    {
      header: t('users.colRole'),
      render: u => {
        const r = ROLE_MAP[u.role];
        if (!r) return u.role;
        const initial = (r.label || u.role).trim().charAt(0).toUpperCase();
        return (
          <span
            className="role-badge"
            data-initial={initial}
            style={{
              padding:'3px 10px', borderRadius:99, fontSize:'0.75rem', fontWeight:700,
              background: r.color + '18', color: r.color,
              display:'inline-block', textAlign:'center', lineHeight:1.35,
              '--role-color': r.color, '--role-color-soft': r.color + '22'
            }}
          >
            {r.label}
          </span>
        );
      }
    },
    { header: t('common.email'), render: u => <span style={{ fontSize:'0.8rem', color:'#6b7280' }}>{u.email || '—'}</span> },
    {
      header: t('common.status'),
      render: u => (
        <span style={{
          padding:'3px 10px', borderRadius:99, fontSize:'0.75rem', fontWeight:700,
          background: u.is_active ? '#d1fae5' : '#fee2e2',
          color: u.is_active ? '#059669' : '#dc2626'
        }}>
          {u.is_active ? t('common.active') : t('common.inactive')}
        </span>
      )
    },
    {
      header: t('common.actions'),
      render: u => (
        <div style={{ display:'flex', gap:6 }}>
          <button className="btn btn-sm btn-secondary" onClick={() => openEdit(u)}>{t('users.btnEdit')}</button>
          <button className="btn btn-sm btn-danger" onClick={() => handleDelete(u)}>{t('users.btnDelete')}</button>
        </div>
      )
    }
  ];

  return (
    <div>
      <PageHeader
        icon="users"
        title={t('users.title')}
        subtitle={filtered.length + ' / ' + users.length + ' ' + t('users.countSuffix')}
        action={<button className="btn btn-primary" onClick={openAdd}>{t('users.btnAdd')}</button>}
      />

      <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginBottom:18 }}>
        <div onClick={() => setFilterRole('_staff')}
          style={{
            background: activeFilter === '_staff' ? '#007c82' : '#fff',
            border: '1.5px solid ' + (activeFilter === '_staff' ? '#007c82' : '#e5e7eb'),
            borderRadius:10, padding:'9px 14px', cursor:'pointer',
            display:'flex', flexDirection:'column', gap:1, minWidth:90, transition:'all 0.15s'
          }}>
          <span style={{ fontSize:'1.3rem', fontWeight:800, color: activeFilter === '_staff' ? '#fff' : '#007c82' }}>{staffCount}</span>
          <span style={{ fontSize:'0.73rem', fontWeight:600, color: activeFilter === '_staff' ? 'rgba(255,255,255,0.9)' : '#374151' }}>{t('users.tabStaff')}</span>
        </div>
        {counts.map(r => (
          <div key={r.value}
            onClick={() => setFilterRole(activeFilter === r.value ? '_staff' : r.value)}
            style={{
              background: activeFilter === r.value ? r.color : '#fff',
              border: '1.5px solid ' + (activeFilter === r.value ? r.color : '#e5e7eb'),
              borderRadius:10, padding:'9px 14px', cursor:'pointer',
              display:'flex', flexDirection:'column', gap:1, minWidth:90, transition:'all 0.15s'
            }}>
            <span style={{ fontSize:'1.3rem', fontWeight:800, color: activeFilter === r.value ? '#fff' : r.color }}>{r.count}</span>
            <span style={{ fontSize:'0.73rem', fontWeight:600, color: activeFilter === r.value ? 'rgba(255,255,255,0.9)' : '#374151' }}>{r.label}</span>
          </div>
        ))}
        <div onClick={() => setFilterRole('_all')}
          style={{
            background: activeFilter === '_all' ? '#374151' : '#fff',
            border: '1.5px solid ' + (activeFilter === '_all' ? '#374151' : '#e5e7eb'),
            borderRadius:10, padding:'9px 14px', cursor:'pointer',
            display:'flex', flexDirection:'column', gap:1, minWidth:90, transition:'all 0.15s'
          }}>
          <span style={{ fontSize:'1.3rem', fontWeight:800, color: activeFilter === '_all' ? '#fff' : '#374151' }}>{users.length}</span>
          <span style={{ fontSize:'0.73rem', fontWeight:600, color: activeFilter === '_all' ? 'rgba(255,255,255,0.9)' : '#374151' }}>{t('users.tabAll')}</span>
        </div>
      </div>

      <div style={{ display:'flex', gap:10, marginBottom:14, flexWrap:'wrap' }}>
        <input
          style={{ padding:'7px 12px', border:'1px solid #e5e7eb', borderRadius:8, fontSize:'0.88rem', flex:1, minWidth:200, maxWidth:300 }}
          placeholder={t('users.searchPlaceholder')}
          value={search} onChange={e => setSearch(e.target.value)}
        />
        <select
          style={{ padding:'7px 12px', border:'1px solid #e5e7eb', borderRadius:8, fontSize:'0.85rem', color:'#374151' }}
          value={filterDept} onChange={e => setFilterDept(e.target.value)}
        >
          <option value="">{t('users.selectAllDepts')}</option>
          {departments.map(d => <option key={d.id} value={d.id}>{lang === 'en' ? t('departments.' + d.name, d.name) : d.name}</option>)}
        </select>

        {/* Yalnız tənzimlənməmişlər — Microsoft ilə yeni girənləri tez tapmaq üçün */}
        {needsSetupCount > 0 && (
          <button
            type="button"
            onClick={() => setOnlyNeedsSetup(v => !v)}
            title={t('users.needsSetupHint')}
            style={{
              display:'inline-flex', alignItems:'center', gap:7,
              padding:'7px 14px', borderRadius:8, cursor:'pointer',
              fontSize:'0.85rem', fontWeight:600, fontFamily:'inherit',
              border:'1px solid ' + (onlyNeedsSetup ? '#f59e0b' : '#fde68a'),
              background: onlyNeedsSetup ? '#f59e0b' : '#fffbeb',
              color: onlyNeedsSetup ? '#fff' : '#92400e',
            }}
          >
            <Icon name="warning" size={14} />
            {t('users.needsSetup')}
            <span style={{
              background: onlyNeedsSetup ? 'rgba(255,255,255,.25)' : '#fde68a',
              color: onlyNeedsSetup ? '#fff' : '#92400e',
              fontSize:'0.72rem', fontWeight:800, padding:'1px 7px', borderRadius:99,
            }}>{needsSetupCount}</span>
          </button>
        )}
      </div>

      {loadError && <div style={{padding:'14px',background:'#fee2e2',color:'#dc2626',borderRadius:8,marginBottom:12,fontSize:'0.85rem'}}><Icon name="warning" size={15} /> {loadError}</div>}
      <DataTable columns={columns} data={filtered} loading={loading} hideSearch
        rowClass={u => u.needs_setup ? 'row-needs-setup' : ''} />

      {modal && (
        <Modal
          title={modal === 'add' ? t('users.modalNew') : t('users.modalEdit')}
          onClose={() => setModal(null)}
        >
          <form onSubmit={handleSave}>
            {modal === 'edit' && (
              <div style={{display:'flex',alignItems:'center',gap:14,marginBottom:14}}>
                {form.avatar ? (
                  <img src={form.avatar} alt="" style={{width:52,height:52,borderRadius:'50%',objectFit:'cover'}} />
                ) : (
                  <div style={{width:52,height:52,borderRadius:'50%',background:'#e0f2f4',color:'#007c82',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,fontSize:'1.2rem'}}>
                    {(form.name || '?').charAt(0).toUpperCase()}
                  </div>
                )}
                <div>
                  <label style={{display:'inline-block',padding:'6px 14px',borderRadius:8,fontSize:'0.82rem',fontWeight:600,cursor:'pointer',background:'#f3f4f6',color:'#374151',border:'1px solid #e5e7eb'}}>
                    {t('users.uploadPhoto')}
                    <input type="file" accept="image/*" style={{display:'none'}} onChange={async e => {
                      const file = e.target.files[0];
                      if (!file) return;
                      const fd = new FormData();
                      fd.append('avatar', file);
                      try {
                        const res = await API.post('/users/' + form.id + '/avatar', fd, {headers:{'Content-Type':'multipart/form-data'}});
                        setForm(p => ({...p, avatar: res.data.avatar}));
                        load();
                      } catch(err) { alert(t('common.fileTooLarge')); }
                    }} />
                  </label>
                  <span style={{fontSize:'0.72rem',color:'#9ca3af',marginLeft:8}}>{t('users.uploadHint')}</span>
                </div>
              </div>
            )}
            <div className="form-row">
              <FormField label={t('users.fieldFullName')}>
                <Input value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} required />
              </FormField>
              <FormField label={t('users.fieldUsername')}>
                <Input value={form.username} onChange={e => setForm(p => ({ ...p, username: e.target.value }))} required />
              </FormField>
            </div>
            <div className="form-row">
              <FormField label={t('common.email')}>
                <Input type="email" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} />
              </FormField>
              <FormField label={t('common.phone')}>
                <Input value={form.phone || ''} onChange={e => setForm(p => ({ ...p, phone: e.target.value }))} />
              </FormField>
            </div>
            <div className="form-row">
              <FormField label={modal === 'add' ? t('users.fieldPasswordRequired') : t('users.fieldPasswordChange')}>
                <div style={{ position: 'relative' }}>
                  <Input type={showPwd ? 'text' : 'password'} value={form.password}
                    onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
                    placeholder={modal === 'edit' ? t('users.passwordPlaceholder') : ''}
                    required={modal === 'add'}
                    style={{ paddingRight: 42 }} />
                  <button type="button" onClick={() => setShowPwd(s => !s)}
                    tabIndex={-1}
                    style={{
                      position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
                      background: 'none', border: 'none', cursor: 'pointer',
                      width: 32, height: 32, borderRadius: 6, color: '#64748b',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f1f5f9'}
                    onMouseLeave={e => e.currentTarget.style.background = 'none'}
                  >
                    {showPwd ? (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/>
                        <line x1="1" y1="1" x2="23" y2="23"/>
                      </svg>
                    ) : (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                      </svg>
                    )}
                  </button>
                </div>
              </FormField>
              <FormField label={t('common.status')}>
                <Select value={form.is_active} onChange={e => setForm(p => ({ ...p, is_active: parseInt(e.target.value) }))}>
                  <option value={1}>{t('common.active')}</option>
                  <option value={0}>{t('common.inactive')}</option>
                </Select>
              </FormField>
            </div>

            <FormField label={t('users.fieldRole')}>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:7, marginTop:4 }}>
                {ROLES.map(r => (
                  <label key={r.value} style={{
                    border: '1.5px solid ' + (form.role === r.value ? r.color : '#e5e7eb'),
                    background: form.role === r.value ? r.color + '12' : '#fff',
                    borderRadius:8, padding:'8px 10px', cursor:'pointer',
                    display:'flex', flexDirection:'column', gap:1,
                    transition:'all 0.12s'
                  }}>
                    <input type="radio" name="role" value={r.value}
                      checked={form.role === r.value}
                      onChange={() => setForm(p => ({ ...p, role: r.value, position: '' }))}
                      style={{ display:'none' }} />
                    <span style={{ fontWeight:700, fontSize:'0.8rem', color: form.role === r.value ? r.color : '#374151' }}>{r.label}</span>
                    <span style={{ fontSize:'0.68rem', color:'#9ca3af' }}>{r.desc}</span>
                  </label>
                ))}
              </div>
            </FormField>

            <div className="form-row">
              <FormField label={t('users.fieldPosition')}>
                {posList.length > 0 ? (
                  <>
                    <Select value={customPos ? '__custom' : (form.position || '')}
                      onChange={e => {
                        if (e.target.value === '__custom') { setCustomPos(true); setForm(p => ({ ...p, position: '' })); }
                        else { setCustomPos(false); setForm(p => ({ ...p, position: e.target.value })); }
                      }}>
                      <option value="">{t('users.selectPosition')}</option>
                      {posList.filter(p => p !== 'Digər').map(pos => <option key={pos} value={pos}>{tPos(pos)}</option>)}
                      <option value="__custom">{t('users.customPosOption')}</option>
                    </Select>
                    {customPos && (
                      <Input value={form.position || ''} onChange={e => setForm(p => ({ ...p, position: e.target.value }))}
                        placeholder={t('users.customPosPlaceholder')} style={{marginTop:6}} />
                    )}
                  </>
                ) : (
                  <Input value={form.position || ''} onChange={e => setForm(p => ({ ...p, position: e.target.value }))} placeholder={t('users.posInputPlaceholder')} />
                )}
              </FormField>

              {showDept && (
                <FormField label={t('users.fieldDept')}>
                  <Select value={form.department_id || ''} onChange={e => setForm(p => ({ ...p, department_id: e.target.value }))}>
                    <option value="">{t('users.selectDept')}</option>
                    {departments.map(d => <option key={d.id} value={d.id}>{lang === 'en' ? t('departments.' + d.name, d.name) : d.name}</option>)}
                  </Select>
                </FormField>
              )}
            </div>

            {/* Birbaşa rəhbər — işburaxma ərizəsi məhz bu şəxsə gedir */}
            <FormField label={t('users.fieldManager')} hint={t('users.managerHint')}>
              <PersonPicker
                value={form.manager_id || ''}
                people={users.filter(u => !['student', 'parent'].includes(u.role) && u.is_active && u.id !== form.id)}
                onChange={v => setForm(p => ({ ...p, manager_id: v || null }))}
                placeholder={t('users.managerSearch')}
                emptyLabel={t('users.managerNone')}
              />
            </FormField>

            {isAdmin && (
            <FormField label={t('users.permsTitle')}>
              {(() => {
                const ALL_MENUS = [
                  {k:'dashboard',l:t('sidebar.dashboard')},
                  {k:'students',l:t('sidebar.students')},
                  {k:'teachers',l:t('sidebar.teachers')},
                  {k:'classes',l:t('sidebar.classes')},
                  {k:'subjects',l:t('sidebar.subjects')},
                  {k:'attendance',l:t('sidebar.attendance')},
                  {k:'grades',l:t('sidebar.grades')},
                  {k:'timetable-builder',l:t('sidebar.timetableBuilder')},
                  {k:'announcements',l:t('sidebar.announcements')},
                  {k:'requests',l:t('sidebar.requests')},
                  {k:'enrollment',l:t('sidebar.enrollment')},
                  {k:'users',l:t('sidebar.users')},
                ];
                let perms = form.menu_permissions;
                if (typeof perms === 'string') { try { perms = JSON.parse(perms); } catch(e) { perms = []; } }
                if (!Array.isArray(perms)) perms = [];
                const allChecked = ALL_MENUS.every(m => perms.includes(m.k));
                const toggleAll = () => {
                  setForm(prev => ({...prev, menu_permissions: allChecked ? [] : ALL_MENUS.map(m => m.k)}));
                };
                return (
                  <div style={{display:'flex',flexWrap:'wrap',gap:6,marginTop:4}}>
                    <label style={{
                      display:'flex',alignItems:'center',gap:4,padding:'4px 10px',borderRadius:6,
                      fontSize:'0.78rem',fontWeight:700,cursor:'pointer',
                      background:allChecked?'#007c82':'#374151',
                      color:'#fff',
                      border:'1px solid '+(allChecked?'#007c82':'#374151'),
                    }}>
                      <input type="checkbox" checked={allChecked} onChange={toggleAll} style={{width:14,height:14}} />
                      {t('common.all')}
                    </label>
                    {ALL_MENUS.map(p => {
                      const checked = perms.includes(p.k);
                      return (
                        <label key={p.k} style={{
                          display:'flex',alignItems:'center',gap:4,padding:'4px 10px',borderRadius:6,
                          fontSize:'0.78rem',fontWeight:600,cursor:'pointer',
                          background:checked?'#e0f2f4':'#f3f4f6',
                          color:checked?'#007c82':'#6b7280',
                          border:'1px solid '+(checked?'#007c82':'#e5e7eb'),
                        }}>
                          <input type="checkbox" checked={checked} onChange={e => {
                            const next = e.target.checked ? [...perms, p.k] : perms.filter(x => x !== p.k);
                            setForm(prev => ({...prev, menu_permissions: next}));
                          }} style={{width:14,height:14}} />
                          {p.l}
                        </label>
                      );
                    })}
                  </div>
                );
              })()}
            </FormField>
            )}

            <div className="form-actions">
              <button type="button" className="btn btn-secondary" onClick={() => setModal(null)}>{t('common.cancel')}</button>
              <SubmitBtn loading={saving}>{modal === 'add' ? t('common.add') : t('common.save')}</SubmitBtn>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
}
